import { useEffect, useRef } from "react";
import { io } from "socket.io-client";
import { useNotifications } from "../context/NotificationContext";

// All events that drive the bell + toast
const NOTIFICATION_EVENTS = [
  "consultation:new",
  "contact:new",
  "quote:new",
  "service-request:new",
];

export function useSocket() {
  const socketRef = useRef(null);
  const { pushNotification } = useNotifications();

  useEffect(() => {
    const token = localStorage.getItem("paladin_admin_token");

    const socketUrl = process.env.REACT_APP_API_URL || undefined;
    const socket = io(socketUrl, {
      auth: { token },
      withCredentials: true,
      transports: ["websocket", "polling"],
    });

    socketRef.current = socket;

    NOTIFICATION_EVENTS.forEach((event) => {
      socket.on(event, (payload) => {
        pushNotification(event, payload);
      });
    });

    socket.on("connect_error", (err) => {
      console.warn("[socket] connect error:", err.message);
    });

    return () => {
      socket.disconnect();
      socketRef.current = null;
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return socketRef;
}